"use client";

interface AddToCartButtonProps {
  onClick?: () => void;
  disabled?: boolean;
  label?: string;
}

export default function AddToCartButton({
  onClick,
  disabled = false,
  label = "Add to cart",
}: AddToCartButtonProps) {
  return (
    <button
      id="add-to-cart-button"
      type="button"
      aria-label={label}
      onClick={onClick}
      disabled={disabled}
      className={`w-full h-10 text-white font-arial text-[15px] sm:text-[18px] font-medium leading-8 rounded-tl-[32px] rounded-br-[32px] border-none inline-block no-underline text-center ${
        disabled
          ? "bg-gray-400 cursor-not-allowed"
          : "bg-[#FF0000] cursor-pointer"
      }`}
      data-test-id={
        disabled ? "add-to-cart-button-disabled" : "add-to-cart-button"
      }
    >
      {label}
    </button>
  );
}
